export default __webpack_public_path__ + "static/slideshow-4-898a1608f7d4f6ea15338005b412fc55.png";